<template>
  <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" :id="id">
    <div class="modal-dialog-centered modal-dialog modal-lg " :class="widthClass"  style="width:1000px" role="document">
      <div
        class="modal-content"
        :style="'background:' + background + ';border-radius:' + radius"
      >
        <div v-if="header" class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <button type="button" class="close" data-dismiss="modal">
            <span :class="color === 'black'? ['text-white']:['text-dark']">&times;</span>
          </button>
        </div>
        <div v-if="body" class="modal-body">
          <slot name="body"></slot>
        </div>
        <div v-if="footer" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @author Huiming Jia
 * @description The base dialog component which is made of a model element, can pop over when use trigger coresponding event. The dialog contains header body and footer slot
 * @module base
 * @name  Dialog
 */
export default {
  /**
   * @property id {property} String contain the theme color of dialog
   * @property color {property} String contain the id informatio of dialog
   * @property title {property} String contain the title of dialog which will be placed in dialog head
   */
  props: {
    header: {
      type: Boolean,
      default: true
    },
    body: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "black"
    },
    background: {
      type: String,
      default: "#2f4552"
    },
    id: {
      type: String,
      default: "Id"
    },
    title: {
      type: String,
      default: "Form"
    },
    radius: {
      type: String,
      default: "4px"
    },

    widthClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="css">
.modal-content {
  padding: 1.6rem;
}

.modal-title{
  font-size: 1.25rem;
  font-weight: 600;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 620px;
  }
}


@media (min-width: 1200px) {
  .modal-dialog-lg {
    max-width: 1100px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/base/modal.vue